module.exports = __webpack_public_path__ + "static/media/vue-tic-tac-toe-cropped.215010c9.PNG";


//////////////////
// WEBPACK FOOTER
// ./src/images/vue-tic-tac-toe-cropped.PNG
// module id = 44
// module chunks = 0